const NotificationTypes = {
    OUT_OF_STOCK: 0,
    LOW_ON_STOCK: 1,
};

export { NotificationTypes };